import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; // 👈 ADDED: Import navigation hook

export default function Topbar({ title }) {
  const { user, doLogout } = useAuth();
  const navigate = useNavigate(); // 👈 ADDED: Initialize navigation
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="flex justify-between items-center bg-white rounded-xl shadow-sm px-6 py-3 mx-6 mt-4">
      
      {/* Left Side: Real Credit Count from Backend */}
      <div className="flex items-center gap-3">
        <div className="text-green-800">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="4" width="22" height="16" rx="2" />
            <path d="M16 12h4" />
            <circle cx="18" cy="12" r="1.5" fill="#1a5c28" />
          </svg>
        </div>
        {/* Dynamically pulls credit_count from your API response */}
        <span className="text-lg font-semibold text-gray-800">
          {user?.credit_count ?? 0}
        </span>
      </div>

      {/* Right Side: User Profile & Dropdown */}
      <div className="relative flex items-center" ref={dropdownRef}>
        <div 
          className="flex items-center gap-3 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span className="text-green-800 font-medium text-sm">{user?.name || 'User'}</span>
          <div className="bg-green-100 rounded-full p-1.5 text-green-800 w-8 h-8 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
          </div>
        </div>

        {/* Dropdown Menu */}
        {isDropdownOpen && (
          <div className="absolute top-12 right-0 bg-white shadow-lg border border-gray-100 rounded-xl min-w-[160px] py-2 z-50">
            
            {/* 👇 FIXED: Profile Item with navigation logic */}
            <div 
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 cursor-pointer"
              onClick={() => {
                setIsDropdownOpen(false); // Close the dropdown
                navigate('/profile');     // Navigate to Profile page
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              Profile
            </div>

            <div className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.66 0 3-4.03 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4.03-3-9s1.34-9 3-9" />
              </svg>
              Sync Data
            </div>
            
            {/* Logout Item */}
            <div 
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 cursor-pointer"
              onClick={() => {
                if (window.confirm('Are you sure you want to log out?')) {
                  doLogout();
                }
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Log out
            </div>
          </div>
        )}
      </div>
    </header>
  );
}